import React, { useContext, useState, useEffect } from "react";
import Button from "@mui/material/Button";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import SendIcon from "@mui/icons-material/Send";
import { Dialog, DialogTitle } from "@mui/material";
import { styled } from "@mui/material/styles";
import PropTypes from "prop-types";

const ChatBoxDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
  backdropFilter: "blur(5px)",
  backgroundColor: "rgba(255, 255, 255,0.1)",
}));

const ChatBoxDialogTitle = (props) => {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
    </DialogTitle>
  );
};

ChatBoxDialogTitle.propTypes = {
  children: PropTypes.node,
  onClose: PropTypes.func.isRequired,
};

const CommentsModal = (props) => {
  return (
    <div>
      <ChatBoxDialog
        onClose={props.handleChatBoxClose}
        aria-labelledby="customized-dialog-title"
        open={props.chatBoxOpen}
      >
        <ChatBoxDialogTitle id="customized-dialog-title">
          <b>Add Comments</b>
          <div className="dialogNextBtn">
            <Button variant="text" onClick={props.handlePrescriptionOpen}>
              Next{" >>"}
            </Button>
          </div>
        </ChatBoxDialogTitle>
        <DialogContent className="chatBoxDialog">
          <Typography gutterBottom>
            Cras mattis consectetur purus sit amet fermentum.
          </Typography>
        </DialogContent>
        <DialogActions>
          <div className="chatBoxInput">
            <TextField
              variant="standard"
              size="small"
              placeholder="Type Your Comment"
              InputProps={{
                disableUnderline: true,
              }}
            />
            <span className="attachFileIcons">
              <AttachFileIcon fontSize="small" />
            </span>
            <span className="sendIcons">
              <SendIcon fontSize="small" />
            </span>
          </div>
        </DialogActions>
      </ChatBoxDialog>
    </div>
  );
};
export { CommentsModal };
